import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { IFacultativeDrawerLovs, IFacultativeDrawerValues } from '.';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const getDrawerSections = (
  lovs: IFacultativeDrawerLovs,
  values: IFacultativeDrawerValues
): IDynamicFormWidgetSection[] => {
  return [
    {
      inputs: {
        linkedTo: {
          name: 'linkedTo',
          title: 'Linked To',
          placeholder: 'Select Linked To',
          type: FormFieldType.select,
          value: values.linkedTo,
          selectOptions: {
            proposal: 'Proposal',
            policy: 'Policy',
          },
          required: true,
        },
        proposal: {
          name: 'proposal',
          title: 'Proposal',
          placeholder: 'Select Proposal',
          type: FormFieldType.autocomplete,
          value: values.proposal,
          conditionalHidden: (values) => values.linkedTo !== 'proposal',
          conditionalRequired: (values) => values.linkedTo === 'proposal',
        },
        policy: {
          name: 'policy',
          title: 'Policy',
          placeholder: 'Select Policy',
          type: FormFieldType.autocomplete,
          value: values.policy,
          conditionalHidden: (values) => values.linkedTo !== 'policy',
          conditionalRequired: (values) => values.linkedTo === 'policy',
        },
        currencySymbol: {
          name: 'currencySymbol',
          title: 'Currency',
          placeholder: 'Currency',
          type: FormFieldType.text,
          value: values.currencySymbol,
          disabled: true,
          required: true,
        },
        cover: {
          name: 'cover',
          title: 'Cover',
          placeholder: 'Select Cover',
          type: FormFieldType.select,
          selectOptions: lovs.covers?.name,
          value: values.cover,
          required: true,
        },
        coverEffectiveDate: {
          name: 'coverEffectiveDate',
          title: 'Cover Effective Date',
          type: FormFieldType.date,
          value: values.coverEffectiveDate,
          required: true,
          disabled: true,
        },
        coverExpiryDate: {
          name: 'coverExpiryDate',
          title: 'Cover Expiry Date',
          type: FormFieldType.date,
          value: values.coverExpiryDate,
          required: true,
          disabled: true,
        },
        reinsurer: {
          name: 'reinsurer',
          title: 'Reinsurer',
          placeholder: 'Type to search reinsurers',
          initialOptions: lovs.reinsurers,
          type: FormFieldType.autocomplete,
          value: values.reinsurer,
          required: true,
        },
      },
    },
  ];
};
